import { Component, OnInit } from "@angular/core";
import { Role } from "../menuService/api/menu-model";
import { MenuService } from "../menuService/api/menu.service";
import { ActivatedRoute, Router } from "@angular/router";
import { roleInterface, Module } from '../menuService/model/roleInterface';
import * as _ from "underscore";
import { MessageService } from "primeng/api";
@Component({
  selector: "app-create-menu",
  templateUrl: "./create-menu.component.html",
  styleUrls: ["./create-menu.component.scss"],
})
export class CreateMenuComponent implements OnInit {
  permissionData: any;
  roleName: string;
  selectedData: any;
  moduleChkBoxNgModel: boolean[] = [];
  featureChkBoxNgModel: boolean[][] = [];
  userTypes: any;
  selectedType: Role;
  editableMode: boolean = false;
  isDisabled: boolean = false;
  roleId: string;
  roleObj: roleInterface;
  shouldUIRender = false;
  mandatoryRole:string = "USER_MGMT";
  message: string = "";
  errorFlag:boolean =false;
  constructor(
    private toast: MessageService,
    private menu: MenuService,
    private router: Router,
    private actRoute: ActivatedRoute
  ) {
    this.roleObj = {
      id: undefined,
      name: "",
      type: "",
      modules: [],
    };
    this.selectedData = [];
    this.userTypes = [
      { name: "karyakarta", value: "KARYA_KARTA" },
      { name: "Viewer", value: "VIEWER" },
      { name: "Office Admin", value: "OFFICE_ADMIN" },
      { name: "Super Admin", value: "SUPER_ADMIN" },
    ];
    let currentUser = JSON.parse(localStorage.getItem("USER_INFO")) 
      this.userTypes.filter((item) =>{
        if(currentUser.accessControl != null){
          if(item.value == currentUser.accessControl.type){
            this.userTypes.pop();
          }
        }
      })
  }
  getData() {
    this.menu.getModules().subscribe((res: any) => {
      this.permissionData = res;
      this.permissionData.forEach((element, index) => {
        this.featureChkBoxNgModel[index] = [];
        element.permissionsMap.forEach((element2, index2) => {

          this.featureChkBoxNgModel[index][index2] = false;
          this.shouldUIRender = true;
        });
      });
      if (this.roleId !== null) {
        this.getEditData();
      }
    });
  }
  selectAllMenu(event){
    this.permissionData.forEach((eleMenu,index) => {
      if(event == true){
        this.moduleChkBoxNgModel[index] = true;
      }else{
        this.moduleChkBoxNgModel[index] = false;
      }
      this.onModuleCheck(eleMenu)    
    });
  }
  onModuleCheck(module) {
    let isExist = this.selectedData.find((ele) => {
      return ele.id === module.id;
    });

    if (isExist) {
      this.selectedData = this.selectedData.filter((ele) => {
        return ele.id != module.id;
      });
    } else {
      let d = {
        name: module.name,
        id: module.id,
        isEnabled: true,
        permissions: [],
      };
      this.selectedData.push(d);
    }
  }
  getEditData() {
    this.editableMode = true;
    this.isDisabled = true;
    this.menu.getEditData(this.roleId).subscribe((roleData) => {
      this.setData(roleData);
    });
  }
  setData(roleData) {
    this.roleObj = roleData;
    this.selectedType = this.userTypes.find((type) => {
      return type.value === this.roleObj.type;
    });
    this.editableMode = true;
    this.isDisabled = true;
    this.selectedData = roleData.modules;
    this.permissionData.forEach((element, index) => {
      this.selectedData.forEach((element2, index2) => {
        if (element2.id == element.id) {
          this.moduleChkBoxNgModel[index] = true;
          element2.permissions.forEach((element3, index3) => {
            element.permissionsMap.forEach((element4, index4) => {
              if (element3.id === element4.id) {
                this.featureChkBoxNgModel[index][index4] = true;
              }
            });
          });
        }
      });
    });
  }

  checkAllOptions(module,event,e,){ 
    this.permissionData.forEach(element => { 
      
      if (module.id == element.id){  
        element.permissionsMap.forEach((ele,index) => {
          let feat = ele;    
            if(event==true){
              this.featureChkBoxNgModel[e][index] = true;
            }else{
              this.featureChkBoxNgModel[e][index] = false;
            }
            this.onFeatureCheck(module,feat,e);
          });
        }       
    });
  }
  onFeatureCheck(module, feature, e) {

    let isExist = undefined;

    this.selectedData.forEach((element) => {
      if (module.id == element.id) {
        isExist = element["permissions"].find((ele) => {
          return ele.id === feature.id;
        });
      }
    });

    if (isExist) {
      this.selectedData.forEach((element) => {
        if (module.id == element.id) {
          element["permissions"] = element["permissions"].filter((ele) => {
            return ele.id != feature.id;
          });
        }
      });
    } else {
      let d = {
        id: feature.id,
      };
      this.selectedData.forEach((element) => {
        if (module.id == element.id) {
          element["permissions"].push(d);
        }
      });
    }
  }
  createRole() {
    if (this.editableMode) {
      let body = {
        name: this.roleObj.name.toUpperCase(),
        type: this.selectedType.value,
        id: +this.roleId,
        modules: this.selectedData,
      };
      this.menu.createRole(body).subscribe(
        () => {
          this.toast.add({
            severity: "success",
            summary: "Updated Successfully",
            detail: "Role Updated Successfully !!!",
          });
          setTimeout(() => {
            this.router.navigate(["/permission-mgmt"]);
          }, 1000);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      let body = {
        name: this.roleObj.name.toUpperCase(),
        type: this.selectedType.value,
        modules: this.selectedData,
      };
      this.menu.createRole(body).subscribe(
        () => {
          this.toast.add({
            severity: "success",
            summary: "Created Successfully",
            detail: "Role Created Successfully !!!",
          });
          setTimeout(() => {
            this.router.navigate(["/permission-mgmt"]);
          }, 1000);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }
  checkUsername(obj) {
    let data = { name: obj };
    this.menu.roleCheck(data).subscribe(
      (res: any) => {
   
      },
      (e) => {
        if (e != undefined) {
          this.errorFlag = true;
        }
        this.message = e.error.message;
      }
    );
  }
  ngOnInit() {
    this.roleId = this.actRoute.snapshot.paramMap.get("roleId");
    setTimeout(() => {
      this.getData();
    });
  }
}
